
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

import { filter } from 'lodash';

function runBlock() {
    'ngInject';

    $(window).load(() =>{
        angular.element(document.body).removeClass('not-ready');   
        if(process.env.NODE_ENV === 'production'){
            window.$ASSETS = window.$ASSETS.map(mapAssets.bind(this));
            window.$ASSETS.forEach(loadAssets.bind(this));
        } else{         
            angular.element(document.querySelector(".stage-container")).removeClass('not-ready');
            angular.element(document.querySelector(".loading-screen")).addClass('not-ready');
        }
    });

    return false;
}

function mapAssets(src){
    return { src: src, loaded: false }
}

function isAssetReady(){
    if(!filter(window.$ASSETS, { loaded: false }).length){
        setTimeout(() => {
            angular.element(document.querySelector(".stage-container")).removeClass('not-ready');
            angular.element(document.querySelector(".loading-screen")).addClass('not-ready');
        }, 1000)
    }
}

function loadAssets(asset){
    let image = new Image();

    image.onload = () => {
        asset.loaded = true
        isAssetReady();
    };
    
    image.src = `assets/images/${asset.src}`;   
}

export default runBlock;



// WEBPACK FOOTER //
// ./src/app/index.run.js